
export const CalculateTireSpacing = (requestObject) => {

    requestObject ??= {};

    const result = {
        isValid: false,
        errors: [],
        tireSpacingResult: null,
        finalTireSizeImperial: null,
        finalTireSizeMetric: null,
    }

    requestObject.wheelOffset = parseFloat(`${requestObject.wheelOffset}`);
    requestObject.desiredTireWidth = parseFloat(`${requestObject.desiredTireWidth}`);

    if (Validate(requestObject, result)) {
        return result;
    }

    result.tireSpacingResult = Math.round((((requestObject.desiredTireWidth * 25.4) / 2) - requestObject.wheelOffset) * 1000) / 1000;
    result.isValid = true;
    return result;
}

export const CalculateFinalTireSize = (requestObject) => {

    requestObject ??= {};

    const result = {
        isValid: false,
        errors: [],
        tireSpacingResult: null,
        finalTireSizeImperial: null,
        finalTireSizeMetric: null,
    }

    requestObject.wheelDiameter = parseFloat(`${requestObject.wheelDiameter}`);
    requestObject.sidewallHeight = parseFloat(`${requestObject.sidewallHeight}`);
    requestObject.desiredTireWidth = parseFloat(`${requestObject.desiredTireWidth}`);

    if (ValidateForFinalTireSize(requestObject, result)) {
        return result;
    }

    let tireAspectRatio = RoundToNearestFactor(((requestObject.sidewallHeight / requestObject.desiredTireWidth) * 100), 5);
    result.finalTireSizeMetric = `Final Tire Size (Metric): ${RoundToNearestFactor((requestObject.desiredTireWidth * 25.4), 5)} / ${tireAspectRatio} R ${requestObject.wheelDiameter}`;

    let tireDiameter = Math.round((2 * requestObject.sidewallHeight) + requestObject.wheelDiameter);
    result.finalTireSizeImperial = `Final Tire Size (Imperial): ${tireDiameter} X ${RoundToNearestFactor(requestObject.desiredTireWidth, 0.5)} R ${requestObject.wheelDiameter}`;

    result.isValid = true;
    return result;
}

const Validate = (requestObject, result) => {

    if (isNaN(requestObject.wheelOffset)) {
        result.errors.push({
            id: "wheelOffset",
            message: "Please enter a valid number"
        })
    }
    if (requestObject.wheelOffset < -500 || requestObject.wheelOffset > 500) {
        result.errors.push({
            id: "wheelOffset",
            message: "Please enter a value between -500 to 500"
        })
    }
    if (isNaN(requestObject.desiredTireWidth)) {
        result.errors.push({
            id: "desiredTireWidth",
            message: "Please select a valid number"
        })
    }
    if (requestObject.desiredTireWidth < 0 || requestObject.desiredTireWidth > 500) {
        result.errors.push({
            id: "desiredTireWidth",
            message: "Please enter a value between 0 to 500"
        })
    }
    return result.errors.length > 0
}

const ValidateForFinalTireSize = (requestObject, result) => {

    if (isNaN(requestObject.desiredTireWidth)) {
        result.errors.push({
            id: "desiredTireWidth",
            message: "Please enter a valid number"
        })
    }
    if (requestObject.desiredTireWidth < 0 || requestObject.desiredTireWidth > 500) {
        result.errors.push({
            id: "desiredTireWidth",
            message: "Please enter a value between 0 to 500"
        })
    }
    if (isNaN(requestObject.wheelDiameter)) {
        result.errors.push({
            id: "wheelDiameter",
            message: "Please enter a valid number"
        })
    }
    if (requestObject.wheelDiameter < 0 || requestObject.wheelDiameter > 500) {
        result.errors.push({
            id: "wheelDiameter",
            message: "Please enter a value between 0 to 500"
        })
    }
    if (isNaN(requestObject.sidewallHeight)) {
        result.errors.push({
            id: "sidewallHeight",
            message: "Please select a valid number"
        })
    }
    if (requestObject.sidewallHeight < 0 || requestObject.sidewallHeight > 500) {
        result.errors.push({
            id: "sidewallHeight",
            message: "Please enter a value between 0 to 500"
        })
    }
    return result.errors.length > 0
}

const RoundToNearestFactor = (number, factor) => {
    return Math.round(number / factor) * factor;
}
